<template>
  <div>
    <h1 class="headline">{{ $t('pages.teamavailabilities.title') }}</h1>
    <v-layout row wrap>
      <v-flex xs12 md4 class="mb-3">
        <stat :title="$t('pages.teamavailabilities.today')">
          <minute :value="todayHoursToday * 60 * 60"></minute>
        </stat>
      </v-flex>
      <v-flex xs12 md4 class="mb-3">
        <stat :title="$t('pages.teamavailabilities.average')">
          <minute :value="averageHours * 60 * 60" ignore-seconds></minute>
        </stat>
      </v-flex>
      <v-flex xs12 md4 class="mb-3">
        <stat :title="$t('pages.teamavailabilities.max')">
          <minute :value="maxHours * 60 * 60"></minute>
        </stat>
      </v-flex>
    </v-layout>
    <v-card>
      <v-toolbar class="transparent elevation-0">
        <v-toolbar-title v-if="interval === 'week'" class="hidden-sm-and-down">
          {{ $t('pages.teamavailabilities.perWeek') }}
        </v-toolbar-title>
        <v-toolbar-title v-else class="hidden-sm-and-down">
          <v-btn icon @click.native.stop="setTimeInterval(previousDay)">
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          {{ $t(`pages.teamavailabilities.days.${interval}`) }}
          <v-btn icon @click.native.stop="setTimeInterval(nextDay)">
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-toolbar-title>
        <v-btn outline primary @click.native.stop="setTimeInterval('week')">{{ $t('pages.teamavailabilities.perWeek') }}</v-btn>
        <v-menu offset-y>
          <v-btn outline primary slot="activator">
            {{ $t('pages.teamavailabilities.perDay') }}
            <v-icon class="primary--text">keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-item v-for="(day, i) in days" :key="day">
              <v-list-tile @click.native="setTimeInterval(i)">
                <v-list-tile-title>{{ $t(`pages.teamavailabilities.days.${i}`) }}</v-list-tile-title>
              </v-list-tile>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <div v-if="experts">
        <availability-experts-per-week
          v-if="interval === 'week'"
          :experts="experts">
        </availability-experts-per-week>
        <availability-experts-per-day
          v-else
          :day="parseInt(interval, 10)"
          :experts="experts">
        </availability-experts-per-day>
      </div>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Availabilities from '@/api/availabilities'
  import AvailabilityExpertsPerDay from '@/components/availabilities/ExpertsPerDay.vue'
  import AvailabilityExpertsPerWeek from '@/components/availabilities/ExpertsPerWeek.vue'
  import Stat from '@/components/Stat.vue'
  import { Minute } from '@/components/formatters'
  export default {
    components: {
      Stat,
      Minute,
      AvailabilityExpertsPerWeek,
      AvailabilityExpertsPerDay
    },
    props: {
      interval: {
        type: String,
        default: 'week'
      }
    },
    computed: {
      ...mapGetters({
        expertsMap: 'skiliko/experts/collection',
        loading: 'skiliko/experts/isLoading'
      }),
      previousDay () { return (parseInt(this.interval, 10) - 1 + 7) % 7 },
      nextDay () { return (parseInt(this.interval, 10) + 1) % 7 },
      expertIds () { return Object.keys(this.expertsMap) },
      experts () {
        return this.expertIds
          .map(id => this.expertsMap[id])
          .filter(e => ['restricted', 'active'].indexOf(e.role) >= 0)
          .sort((a, b) => a.priority - b.priority)
      },
      totalHoursPerDay () { return Availabilities.totalHoursPerDay(this.experts) },
      todayHoursToday () { return this.totalHoursPerDay[new Date().getDay()] },
      averageHours () { return (this.totalHoursPerDay.reduce((sum, hour) => sum + hour, 0) / this.expertIds.length).toFixed(2) },
      maxHours () { return Availabilities.maxHourPerDay(this.experts) },
      days () { return new Array(7) }
    },
    methods: {
      ...mapActions({
        fetchAvailabilities: 'skiliko/experts/availabilities'
      }),
      setTimeInterval (interval) {
        this.$router.replace({
          ...this.$route,
          query: { interval: interval.toString() }
        })
      }
    },
    mounted () {
      this.fetchAvailabilities()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/TeamAvailabilities.vue